<template>
<span>
<p><span style="font-size:10pt">Inhalt der Leistung:</span></p>

<ul>
  <li>
    <p><span style="font-size:10pt">Pr&uuml;fung der Fehlerstromgr&ouml;&szlig;en</span></p>
  </li>
  <li>
    <p><span style="font-size:10pt">Auslegung der (Netzbetriebs-) Erdung</span></p>
  </li>
  <li>
    <p><span style="font-size:10pt">Simulationsergebnisse Erdpotentialanhebung</span></p>
  </li>
  <li>
    <p><span style="font-size:10pt">Simulationsergebnisse Ber&uuml;hrspannung</span></p>
  </li>
  <li>
    <p><span style="font-size:10pt">Simulationsergebnisse Schrittspannung</span></p>
  </li>
  <li>
    <p><span style="font-size:10pt">Ermittlung der sicheren Bereiche</span></p>
  </li>
  <li>
    <p><span style="font-size:10pt">Angaben zum verwendeten Material</span></p>
  </li>
</ul>

<p><span style="font-size:9pt"><em>Optional: Nach Durchf&uuml;hrung der Leistung k&ouml;nnen wir Ihnen ein vollst&auml;ndiges Erdungskonzept erstellen.</em></span></p>

</span>
</template>

<script>
export default {
  name: "TooltipErdungssimulationBlitzTrafo"
}
</script>

<style scoped>

</style>
